module.exports = __webpack_public_path__ + "img/icone-mentor.23150579.svg";